// 线上图片地址
export const imgUrl =  'http://www.hzinvest.cn/uploads/'